export default function AgencySpendSection({ agencySpend, formatCurrency }) {
  const entries = Object.entries(agencySpend || {});
  return (
    <div className="card-flat" data-testid="agency-spend-section">
      <h2 className="text-lg font-semibold mb-4">Agency-wise Spend</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {entries.length > 0 ? (
          entries.map(([name, amount]) => (
            <div key={name} className="p-4 bg-gray-50 border border-gray-200">
              <div className="text-sm text-gray-600 mb-1">{name}</div>
              <div className="font-mono text-xl font-bold">{formatCurrency(amount)}</div>
            </div>
          ))
        ) : (
          <div className="text-gray-500 text-sm col-span-3">No bookings yet</div>
        )}
      </div>
    </div>
  );
}
